import React, { useEffect, useState } from 'react';
import './contributions.css';

const GITHUB_USERNAME = 'gvns0x';
const CONTRIBUTIONS_URL = `https://github-contributions-api.jogruber.de/v4/${GITHUB_USERNAME}?y=last`;
const MONTHS_VISIBLE = 3;

function sliceLastMonths(contributions, months) {
    if (!contributions.length) {
        return [];
    }

    const sorted = [...contributions].sort((a, b) => a.date.localeCompare(b.date));
    const last = toUtcDate(sorted[sorted.length - 1].date);
    const cutoff = new Date(last);
    cutoff.setUTCMonth(cutoff.getUTCMonth() - months);
    const cutoffIso = formatIsoDate(cutoff);

    return sorted.filter((day) => day.date >= cutoffIso);
}

function toUtcDate(isoDate) {
    return new Date(`${isoDate}T00:00:00Z`);
}

function formatIsoDate(date) {
    return date.toISOString().slice(0, 10);
}

function groupIntoWeeks(contributions) {
    if (!contributions.length) {
        return [];
    }

    const byDate = new Map(contributions.map((day) => [day.date, day]));
    const sorted = [...contributions].sort((a, b) => a.date.localeCompare(b.date));
    const first = toUtcDate(sorted[0].date);
    const last = toUtcDate(sorted[sorted.length - 1].date);

    const start = new Date(first);
    start.setUTCDate(start.getUTCDate() - start.getUTCDay());

    const end = new Date(last);
    end.setUTCDate(end.getUTCDate() + (6 - end.getUTCDay()));

    const days = [];
    for (let cursor = new Date(start); cursor <= end; cursor.setUTCDate(cursor.getUTCDate() + 1)) {
        const date = formatIsoDate(cursor);
        const day = byDate.get(date);
        days.push({
            date,
            count: day ? day.count : 0,
            level: day ? Math.min(Math.max(day.level, 0), 4) : 0
        });
    }

    const weeks = [];
    for (let i = 0; i < days.length; i += 7) {
        weeks.push(days.slice(i, i + 7));
    }
    return weeks;
}

export default function Contributions() {
    const [weeks, setWeeks] = useState(null);

    useEffect(() => {
        const controller = new AbortController();

        async function loadContributions() {
            try {
                const response = await fetch(CONTRIBUTIONS_URL, { signal: controller.signal });
                if (!response.ok) {
                    throw new Error('Failed to load contributions');
                }

                const data = await response.json();
                const grouped = groupIntoWeeks(
                    sliceLastMonths(data.contributions || [], MONTHS_VISIBLE)
                );
                if (!controller.signal.aborted) {
                    setWeeks(grouped.length ? grouped : []);
                }
            } catch (error) {
                if (error.name === 'AbortError') {
                    return;
                }
                setWeeks([]);
            }
        }

        loadContributions();

        return () => controller.abort();
    }, []);

    if (!weeks || weeks.length === 0) {
        return null;
    }

    return (
        <div className="contributions">
            <div className="contributions-grid">
                {weeks.map((week) => (
                    <div className="contributions-week" key={week[0].date}>
                        {week.map((day) => (
                            <span
                                key={day.date}
                                className={`contributions-day contributions-day--level-${day.level}`}
                            />
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
